<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="">
        <el-form ref="form" :model="user" label-position="top" size="small">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="My email">
                <el-input v-model="user.email" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="Brand name">
                <el-input v-model="user.master_brand_name" :disabled="user.register_type == 'invite_existing_brand'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="My phone number">
                <el-input v-model="user.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="Brand website">
                <el-input v-model="user.brand_website"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="My first name">
                <el-input v-model="user.first_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="My last name">
                <el-input v-model="user.last_name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Company name">
                <el-input v-model="user.company_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="Company website">
                <el-input v-model="user.company_website"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Company phone number">
                <el-input v-model="user.company_phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Address line 1">
                <el-input v-model="user.address_line_1"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="Address line 2">
                <el-input v-model="user.address_line_2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="City">
                <el-input v-model="user.city"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="State or Province or Region">
                <el-input v-model="user.state_province_region"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Postal code">
                <el-input v-model="user.postal_code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="Country">
                <el-input v-model="user.country"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-col :span="10" class="form-item-brand">
            <el-form-item label="Master Brand">
              <el-select v-model="user.master_brand_id" filterable style="width: 100%;" @change="selectBrand">
                <el-option v-for="(item) in brands" :key="item._id" :label="item.name" :value="item._id"></el-option>
              </el-select>
            </el-form-item>
            <div class="form-item-brand-link">
              <span>(Don't have your brand? </span>
              <el-button type="text" size="mini">CREATE ONE</el-button>
              <span>)</span>
            </div>
          </el-col> -->
          <el-row style="margin-top: 30px;">
            <el-form-item>
              <el-button class="el-btn-blue" @click="updateUser" size="small" :loading="flagLoading.save">SAVE CHANGES</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ClientProfile',
  components: {
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    return {
      user: {},
      brands: [],
      flagLoading
    }
  },
  created () {
    this.getBrands()
  },
  mounted () {
    this.user = this.userInfo
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
  },
  methods: {
    updateUser: function () {
      const that = this
      this.flagLoading.save = true
      const url = '/api/v1/atk_player/users/profile'
      this.$service.put(url, this.user).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Your profile has been updated successfully' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateUser', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    getBrands: function () {
      const url = '/api/v1/atk_player/brands?page_num=1&page_size=1000'
      const that = this
      this.$service.get(url).then((res) => {
        if (res.code === 200) {
          that.brands = res.data.list
        }
      }).catch((err) => {
        console.error('getBrands', err)
      }).then(() => {
      })
    },
    selectBrand: function (val) {
      let brand = {}
      brand = this.brands.find(item => item._id === val)
      this.user.brand_name = brand.name
    }
  }
}
</script>
<style lang="scss">
.form-item-brand {
  position: relative;
  .form-item-brand-link {
    position: absolute;
    top: 0;
    left: 100px;
    line-height: 32px;
    color: #606266;
  }
}
</style>
